import React, { useMemo, useRef, useState, useCallback, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "../../../../components/common/datatable/DataTable.css";
import { provideGlobalGridOptions } from 'ag-grid-community';
import ButtonComponent from "../../../../components/common/button/Button";
import "./RegionalViewerForecast.css"; // CSS shown below
import { Badge, Box, Checkbox, CircularProgress, IconButton, ListItemText, MenuItem, Popover, Select } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import HistoryDataTable from "../HistoryDataTable";
import HistoryIcon from '@mui/icons-material/History';
import { Loader } from "../../../../components/common/Loader";
import { postHideColumns } from "../../../../redux/actions/PostHideColumnsSlice";
import CopyPasteDateRows from "../CopyPasteDateRows";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { hiddenColumnsEndpoint } from "../../../../common/endpoints";
import { getHideColumnsList } from "../../../../redux/actions/GetHideColumnsListSlice";
import "ag-grid-enterprise";
import { saveAs } from 'file-saver';
import ExcelJS from 'exceljs';
import UploadExcelModal from "../UploadExcelModal";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { Radio, FormControlLabel } from "@mui/material";
import { getBuyerForecastSaveDataEndpoint, submitBuyerForecastOverrideDataEndpoint } from "../../../../common/endpoints";
import { getBuyerForecastSaveDataSlice } from "../../../../redux/actions/BuyerForecastSaveDataSlice";
import { submitBuyerForecastOverrideDataSlice } from "../../../../redux/actions/submitBuyerForecastOverrideDataSlice";
import { DateComparator } from "../../../../components/common/DateComparator";
import { formatDate } from "../../../../components/common/FormatDate";
import { setGridSelectedRows, clearGridSelectedRows } from '../../../../redux/actions/gridSelectedRowsSlice';
import { VariantViewModal } from "../VariantViewModal";
import { ShowVariantViewModal } from "../ShowVariantViewModal";

provideGlobalGridOptions({
    theme: "legacy"
})

const RegionalViewerDataTable = ({ forecastTableData, isLoading, selectedStartingFrom, selectedViewBy, setSelectedViewBy, keyFigureMappingCPS, keyFigureMappingDPS, selectedViewByOptions, setSelectedViewByOptions, getSupplierForecastTable }) => {
    const originalData = forecastTableData || [];
    const gridRef = useRef();
    const [gridApi, setGridApi] = useState();
    const [disableFilterBtn, setDisableFilterBtn] = useState(true);
    const [disableSortBtn, setDisableSortBtn] = useState(true);
    const [openHistoryModal, setOpenHistoryModal] = useState(false);
    const [historySelectedRowData, setHistorySelectedRowData] = useState({});
    const [isRadioSelected, setIsRadioSelected] = useState(false);
    const [badgeCount, setBadgeCount] = useState();
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [openCopyPasteModal, setOpenCopyPasteModal] = useState(false);
    const [loadingCopyPaste, setLoadingCopyPaste] = useState(false);
    const [copyPasteSelectedRowData, setCopyPasteSelectedRowData] = useState(false);
    const [openCreateVariantModal, setOpenCreateVariantModal] = useState(false);
    const [openShowVariantModal, setOpenShowVariantModal] = useState(false);
    const [variantData, setVariantData] = useState({});
    const savedFilterModel = localStorage.getItem("savedVariantFilterModel");
    const stateUpdate = useSelector((state) => state?.getforecastEmailSlice);
    const editedRowsRef = useRef([]);

    const hasDpsData = originalData?.forecast?.some(item => item?.businessCategory === "DPS") ?? false;

    // const [columnFilterDropdownOption, setColumnFilterDropdownOption] = useState([]);
    const pagination = true;
    const paginationPageSize = 500;
    const paginationPageSizeSelector = [10, 50, 100, 500, 1000];
    const stateBuyerForecastTableDataSlice = useSelector((state) => state.getBuyerForecastTableData);
    const SubmitBuyerForecastOverrideDataSlice = useSelector((state) => state.submitBuyerForecastOverrideDataSlice);
    const [appliedHiddenColumns, setAppliedHiddenColumns] = useState([]);
    const [isDownloading, setIsDownloading] = useState(false);
    const [openUploadModal, setOpenUploadModal] = useState(false);
    const initialFilterAppliedRef = useRef(false);

    const userEmail = localStorage.getItem("userEmail");
    const userRole = localStorage.getItem("userRole");

    const dispatch = useDispatch();
    const stateSelector = useSelector((state) => state);
    const globalSelectedRows = useSelector((state) => state.gridSelectedRows.selectedRows);
    const saveTable = useSelector((state) => state.getBuyerForecastSaveDataSlice);
    const submitForecast = useSelector((state) => state.submitBuyerForecastOverrideDataSlice);
    const previousGlobalSelectionCountRef = useRef(globalSelectedRows?.length || 0);

    useEffect(() => {
        const previousCount = previousGlobalSelectionCountRef.current;
        const currentCount = globalSelectedRows?.length || 0;

        if (previousCount > 0 && currentCount === 0) {
            const api = gridRef?.current?.api ?? gridRef?.current;
            if (api?.deselectAll) {
                api.deselectAll();
            }
            setSelectedRows([]);
        }

        previousGlobalSelectionCountRef.current = currentCount;
    }, [globalSelectedRows]);

    useEffect(() => {
        fetchHideColumnsData()
    }, [])

    const buildInitialFilterModel = useCallback(() => {
        const model = {};

        // Get the two dates from stateUpdate
        const latestCpsDate = stateUpdate?.latestCpsDate;
        const latestDpsDate = stateUpdate?.latestDpsDate;

        // Only include non-empty values
        const values = [latestCpsDate, latestDpsDate].filter(Boolean);

        if (values.length > 0) {
            // Apply filter only on lastCustUpdate column
            model.lastCustUpdate = {
                filterType: "multi",
                filterModels: [
                    null,
                    {
                        filterType: "set",
                        values: values, // one or both dates
                    },
                ],
            };
        }

        return model;
    }, [stateUpdate]);

    const onGridReady = (params) => {
        setGridApi(params?.api);
        gridRef.current = params.api;
        setDisableSortBtn(false);
    }

    const onFilterChanged = (params) => {
        if (gridRef.current) {
            const filterModel = gridRef.current.getFilterModel();
            setDisableFilterBtn(Object.keys(filterModel).length === 0);
        }

        let hasDPS = false;

        for (let i = 0; i < params?.api?.getDisplayedRowCount(); i++) {
            const rowNode = params?.api?.getDisplayedRowAtIndex(i);

            if (rowNode?.data?.businessCategory === "DPS") {
                hasDPS = true;
                break;
            }
        }

        if (hasDPS) {
            setSelectedViewByOptions(prev =>
                prev?.includes("Weekly")
                    ? ["Monthly", "Yearly"]
                    : prev?.includes("Hybrid")
                        ? ["Monthly", "Yearly"] : prev
            );

            setSelectedViewBy(prev => prev === "Weekly" ? "Monthly" : prev === "Hybrid" ? "Monthly" : prev);
        } else {
            setSelectedViewByOptions(prev =>
                prev && !prev.includes("Weekly")
                    ? ["Weekly", "Monthly", "Yearly", "Hybrid"]
                    : prev
            );
        }
    };
    const onSortChanged = (params) => {
        const colState = params.api.getColumnState();
        const isAnySortApplied = colState.some(col => col.sort);
        setDisableSortBtn(isAnySortApplied);
    };
    const gridOptions = {
        // getRowId: (params) => {
        //   return `${params?.data?._groupIndex}-${params?.data?._rowIndexInGroup}`
        // },
        onFilterChanged,
        overlayLoadingTemplate: `<span class="ag--overlay-loading-center" >Please wait while data is loading</span>`,
        overlayNoRowsTemplate: `<span class="ag--overlay-no-rows-center" >No Data Available</span>`,
        defaultColDef: {
            valueGetter: (params) => {
                if (!params.data) return "-";

                const field = params.colDef.field;
                const value = params.data[field];

                return value === null || value === undefined || value === "" ? "-" : value;
            },

        }

    }

    const handleOpenHistoryData = (data) => {
        setOpenHistoryModal(true);
        setHistorySelectedRowData(data)
    }
    const handleCloseShowHistoryModal = (a, b) => {
        setOpenHistoryModal(false);
        setHistorySelectedRowData({})
    }

    const rowSpanFn = useCallback((params) => {
        if (!params.data) return 1;
        return params.data._rowIndexInGroup === 0 ? params.data._rowCountInGroup : 1;
    }, []);

    const [rowData, setRowData] = useState([]);

    useEffect(() => {
        if (selectedViewBy === "Hybrid" || selectedViewBy === "Yearly" || selectedViewBy === "Monthly" || hasDpsData) {
            setIsRadioSelected(false);
        }
    }, [selectedViewBy, hasDpsData]);

    useEffect(() => {
        if (!gridRef.current) return;
        if (!rowData?.length) return;
        if (!stateUpdate?.latestCpsDate && !stateUpdate?.latestDpsDate) return;
        if (initialFilterAppliedRef.current) return;

        const filterModel = buildInitialFilterModel();

        // Only apply if at least one date exists
        if (Object.keys(filterModel).length) {
            gridRef.current.setFilterModel(filterModel);
            gridRef.current.onFilterChanged();
            initialFilterAppliedRef.current = true;
        }
    }, [rowData, stateUpdate, buildInitialFilterModel]);

    useEffect(() => {
        if (originalData && originalData.length > 0 && keyFigureMappingCPS && keyFigureMappingDPS) {
            const newRowData = transformOriginalForecastData(originalData, selectedViewBy, keyFigureMappingCPS, keyFigureMappingDPS);
            setRowData(newRowData); // Set the processed data to state
        }
    }, [originalData, selectedViewBy, keyFigureMappingCPS, keyFigureMappingDPS]);

    const dateColumns = rowData && rowData.length > 0
        ? Object.keys(rowData[0]).filter((k) =>
            k.match(/(\d{1,2} [A-Za-z]{3} \d{4})|([A-Za-z]{3} \d{4})|(\d{4})/)  // Matches "Dec 2024", "Jan 2025", etc.
        )
        : [];

    // Function to transform the data
    const transformOriginalForecastData = (forecastData, viewBy, keyFigureCPS, KeyFigureDPS) => {
        const result = [];

        forecastData.forEach((item, groupIndex) => {
            const currentKeyFigureMap =
                item.businessCategory === "DPS"
                    ? KeyFigureDPS
                    : keyFigureCPS;

            const timeline =
                viewBy === "Weekly" ? "weeklyTimeline"
                    : viewBy === "Yearly" ? "yearlyTimeline"
                        : viewBy === "Hybrid"
                            ? item.hybridTimeline ? "hybridTimeline" : "monthlyTimeline"
                            : "monthlyTimeline";

            const timelineData = item[timeline] || {};

            // Iterate through each key figure (k1, k2, etc.)
            Object.keys(currentKeyFigureMap).forEach((kfKey, rowIndexInGroup) => {
                const keyFigureName = currentKeyFigureMap[kfKey];
                const keyFigureData = {
                    tcccMaterialNumber: item.materialId,
                    description: item.materialDescription,
                    materialGroupDesc: item.materialGroupDesc,
                    supplierPIN: item.supplierPin,
                    supplierId: [item.supplierId, item.supplierName].filter(Boolean).join(" | "),
                    packSize: item.packSize,
                    blockedStock: item.blockedStock,
                    incoterm: item.incoTerm,
                    incoterm1: item.incoTerm1,
                    country: [item.locationGeography, item.countryName].filter(Boolean).join(" | "),
                    plantCode: item.plant,
                    plantDescription: item.plantName,
                    purchasingGroup: [item.purchasingGroup, item.purchasingGroupDesc].filter(Boolean).join(" | "),
                    locationGeography: item.locationGeography,
                    locationNationalRegion: item.locationNationalRegion,
                    parentVendorName: item.parentVendorName,
                    vendorCodeName: item.vendorCodeName,
                    businessCategory: item.businessCategory,
                    lastCustUpdate: item.lastCustomerUpdate,
                    lastSuppUpdate: item.lastSupplierUpdate,
                    publishDate: item.publishDate,
                    unit: item.unit,
                    status: item.status,
                    plannerCode: item.plannerCode,
                    materialGroup: item.materialGroup,
                    mrpController: [item.mrpController, item.mrpControllerName].filter(Boolean).join(" | "),
                    scode: item.scode,
                    snpPlanner: [item.snpPlanner, item.snpPlannerDescription].filter(Boolean).join(" | "),
                    keyfigureName: keyFigureName,
                    _groupIndex: groupIndex,
                    _rowIndexInGroup: rowIndexInGroup
                };

                if (item.businessCategory !== "DPS" || timeline !== "weeklyTimeline") {
                    // Extract the timeline and add each date
                    Object.keys(timelineData).forEach((date) => {
                        // Set date value for the specific key figure
                        keyFigureData[date] = timelineData[date]?.[kfKey] ?? null;
                    });
                }

                keyFigureData.total = calculateTotal(keyFigureData)

                // Push the keyFigureData object to result (one for each key figure)
                result.push(keyFigureData);
            });
        });

        return result;
    };

    const calculateTotal = (row) => {
        // Skip total calculation for Comments row
        if (row.keyfigureName?.toLowerCase() === "comments") {
            return 0;
        }
        // Include only date-formatted columns (ignore Comments or text columns)
        const dateCols = Object.keys(row).filter((k) =>
            k.match(/(\d{1,2} [A-Za-z]{3} \d{4})|([A-Za-z]{3} \d{4})|(\d{4})/) && k.toLowerCase() !== "comments"
        );
         if (!dateCols.length) return 0;

        // For "Open Allocation", return the last non-null value
        if (row.keyfigureName?.toLowerCase() === "open allocation") {
            for (let i = dateCols.length - 1; i >= 0; i--) {
            const val = parseFloat(row[dateCols[i]]);
            if (!isNaN(val)) {
                return val;
            }
            }
            return null;
        }
        const total = dateCols.reduce((sum, key) => {
            const val = parseFloat(row[key]);
            return isNaN(val) ? sum : sum + val;
        }, 0);
        return total;
    };

    const cellRenderCheck = (params) => {
        const dateFields = ["lastCustUpdate", "publishDate"];

        const value = dateFields.includes(params.colDef.field)
            ? formatDate(params.value)
            : params.value;

        if (params.data._rowIndexInGroup === 0 && disableFilterBtn) {
            return value;
        } else if (!disableFilterBtn) {
            return value;
        } else if (disableSortBtn) {
            return value;
        }
    };

    const formatTotal = (params) => {
        const row = params.data;
        let value = params.value;

        if (row?.keyfigureName?.toLowerCase() === "comments") {
            return "";
        }

        if (value == null || isNaN(value)) return "";

        const rounded = Math.round(value * 100) / 100;

        if (Number.isInteger(rounded)) {
            return rounded.toString();
        }

        return rounded.toString();
    };
    const columnDefs = [
        {
            headerName: "TCCC Material Number", field: "tcccMaterialNumber",
            pinned: 'left',
            lockPinned: true,
            lockPosition: true,
            width: 200,
            wrapText: true,
            autoHeight: true,
            cellClass: "wrap-cell",
        },
        {
            headerName: "Description", field: "description", optionalField: true,
            rowSpan: rowSpanFn,
            cellRenderer: (params) => cellRenderCheck(params), width: 150,
            wrapText: true,
            autoHeight: true,
            cellClass: "wrap-cell",
        },
        {
            headerName: "Plant Code", field: "plantCode", optionalField: true,
            rowSpan: rowSpanFn,
            cellRenderer: (params) => cellRenderCheck(params), width: 140,
            wrapText: true,
            autoHeight: true,
            cellClass: "wrap-cell",
        },
        {
            headerName: "Plant Description", field: "plantDescription", optionalField: true,
            rowSpan: rowSpanFn,
            cellRenderer: (params) => cellRenderCheck(params), width: 180,
            wrapText: true,
            autoHeight: true,
            cellClass: "wrap-cell",
        },
        // {
        //   headerName: "Supplier PIN", field: "supplierPIN", optionalField: true,
        //   rowSpan: rowSpanFn,
        //   cellRenderer: (params) => cellRenderCheck(params), width: 150,
        //   wrapText: true,
        //   autoHeight: true,
        //   cellClass: "wrap-cell",
        // },
        {
            headerName: "Purchase Group", field: "purchasingGroup", optionalField: true,
            rowSpan: rowSpanFn,
            cellRenderer: (params) => cellRenderCheck(params), width: 150,
            wrapText: true,
            autoHeight: true,
            cellClass: "wrap-cell",
        },
        // {
        //   headerName: "Location geography", field: "locationGeography", optionalField: true,
        //   rowSpan: rowSpanFn,
        //   cellRenderer: (params) => cellRenderCheck(params),
        // },
        // {
        //   headerName: "Location National Region", field: "locationNationalRegion", optionalField: true,
        //   rowSpan: rowSpanFn,
        //   cellRenderer: (params) => cellRenderCheck(params),
        // },
        {
            headerName: "Material Group Description", field: "materialGroupDesc", optionalField: true,
            rowSpan: rowSpanFn,
            cellRenderer: (params) => cellRenderCheck(params),
            wrapText: true,
            autoHeight: true,
            cellClass: "wrap-cell",
        },
        {
            headerName: "Parent Vendor Name", field: "parentVendorName", optionalField: true,
            rowSpan: rowSpanFn,
            cellRenderer: (params) => cellRenderCheck(params),
            wrapText: true,
            autoHeight: true,
            cellClass: "wrap-cell",
        },
        {
            headerName: "Vendor Code", field: "supplierId", optionalField: true,
            rowSpan: rowSpanFn,
            cellRenderer: (params) => cellRenderCheck(params),
            wrapText: true,
            autoHeight: true,
            cellClass: "wrap-cell",
        },
        {
            headerName: "Business Category", field: "businessCategory", optionalField: true,
            rowSpan: rowSpanFn,
            cellRenderer: (params) => cellRenderCheck(params), width: 160,
            wrapText: true,
            autoHeight: true,
            cellClass: "wrap-cell",
        },
        {
            headerName: "Pack Size", field: "packSize", optionalField: true,
            rowSpan: rowSpanFn,
            cellRenderer: (params) => cellRenderCheck(params), width: 140,
            wrapText: true,
            autoHeight: true,
            cellClass: "wrap-cell",
        },
        {
            headerName: "Blocked Stock", field: "blockedStock", optionalField: true,
            rowSpan: rowSpanFn,
            cellRenderer: (params) => cellRenderCheck(params), width: 140,
            wrapText: true,
            autoHeight: true,
            cellClass: "wrap-cell",
        },
        {
            headerName: "Unit", field: "unit", optionalField: true,
            rowSpan: rowSpanFn,
            cellRenderer: (params) => cellRenderCheck(params), width: 130,
            wrapText: true,
            autoHeight: true,
            cellClass: "wrap-cell",
        },
        {
            headerName: "Incoterm", field: "incoterm", optionalField: true,
            rowSpan: rowSpanFn,
            cellRenderer: (params) => cellRenderCheck(params), width: 150,
            wrapText: true,
            autoHeight: true,
            cellClass: "wrap-cell",
        },
        {
            headerName: "Incoterm1", field: "incoterm1", optionalField: true,
            rowSpan: rowSpanFn,
            cellRenderer: (params) => cellRenderCheck(params), width: 150,
            wrapText: true,
            autoHeight: true,
            cellClass: "wrap-cell",
        },
        {
            headerName: "Region and Country", field: "country", optionalField: true,
            rowSpan: rowSpanFn,
            cellRenderer: (params) => cellRenderCheck(params), width: 180,
            wrapText: true,
            autoHeight: true,
            cellClass: "wrap-cell",
        },
        {
            headerName: "Material Group", field: "materialGroup", optionalField: true,
            rowSpan: rowSpanFn,
            cellRenderer: (params) => cellRenderCheck(params), width: 150,
            wrapText: true,
            autoHeight: true,
            cellClass: "wrap-cell",
        },
        {
            headerName: "External Material Group", field: "scode", optionalField: true,
            rowSpan: rowSpanFn,
            cellRenderer: (params) => cellRenderCheck(params),
            wrapText: true,
            autoHeight: true,
            cellClass: "wrap-cell",
        },
        {
            headerName: "MRP controller", field: "mrpController", optionalField: true,
            rowSpan: rowSpanFn,
            cellRenderer: (params) => cellRenderCheck(params),
            wrapText: true,
            autoHeight: true,
            cellClass: "wrap-cell",
        },
        {
            headerName: "GMP", field: "snpPlanner", optionalField: true,
            rowSpan: rowSpanFn,
            cellRenderer: (params) => cellRenderCheck(params), width: 150,
            wrapText: true,
            autoHeight: true,
            cellClass: "wrap-cell",
        },
        {
            headerName: "Last Cust Update", field: "lastCustUpdate", optionalField: true,
            rowSpan: rowSpanFn,
            cellRenderer: (params) => cellRenderCheck(params), width: 160,
            wrapText: true,
            autoHeight: true,
            cellClass: "wrap-cell",
            comparator: DateComparator,
            valueFormatter: (params) => formatDate(params.value),
            filterParams: {
                filters: [
                    {
                        filter: "agTextColumnFilter",
                    },
                    {
                        filter: "agSetColumnFilter",
                        filterParams: {
                            valueFormatter: (params) => formatDate(params.value),
                            excelMode: "windows",
                            suppressMiniFilter: false,
                            buttons: ["apply", "reset"],
                        },
                    },
                ],
            }
        },
        {
            headerName: "Last Supp Update", field: "lastSuppUpdate", optionalField: true,
            rowSpan: rowSpanFn,
            cellRenderer: (params) => cellRenderCheck(params), width: 160,
            wrapText: true,
            autoHeight: true,
            cellClass: "wrap-cell",
            comparator: DateComparator,
        },
        {
            headerName: "Publish Date", field: "publishDate", optionalField: true,
            rowSpan: rowSpanFn,
            cellRenderer: (params) => cellRenderCheck(params), width: 160,
            wrapText: true,
            autoHeight: true,
            cellClass: "wrap-cell",
            comparator: DateComparator,
            valueFormatter: (params) => formatDate(params.value),
            filterParams: {
                filters: [
                    {
                        filter: "agTextColumnFilter",
                    },
                    {
                        filter: "agSetColumnFilter",
                        filterParams: {
                            valueFormatter: (params) => formatDate(params.value),
                            excelMode: "windows",
                            suppressMiniFilter: false,
                            buttons: ["apply", "reset"],
                        },
                    },
                ],
            }
        },
        // {
        //   headerName: "Planner Code", field: "plannerCode", optionalField: true,
        //   rowSpan: rowSpanFn,
        //   cellRenderer: (params) => cellRenderCheck(params), width: 150,
        //   wrapText: true,
        //   autoHeight: true,
        //   cellClass: "wrap-cell",
        // },
        {
            headerName: "Status", field: "status", optionalField: true,
            rowSpan: rowSpanFn,
            cellRenderer: (params) => cellRenderCheck(params), width: 150,
            wrapText: true,
            autoHeight: true,
            cellClass: "wrap-cell",
        },
        {
            headerName: "Key Figures",
            field: "keyfigureName",
            pinned: 'left',
            lockPinned: true,
            lockPosition: true,
            wrapText: true,
            autoHeight: true,
            cellClass: "wrap-cell",
            cellRenderer: (response) => {
                return (
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <span>{response.value}</span>

                        {/* Show History icon only for "Forecast Pickup" */}
                        {response.value === "Forecast Pickup" && (
                            <div
                                style={{
                                    display: "flex",
                                    cursor: "pointer",
                                    marginLeft: 10,
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                                onClick={() => handleOpenHistoryData(response.data)}
                            >
                                <HistoryIcon style={{ fontSize: 20 }} />
                            </div>
                        )}
                    </div>
                );
            },
        },

        ...dateColumns.map((date) => ({
            headerName: date,
            field: date,
            width: 180,
            wrapText: true,
            autoHeight: true,
            cellClass: "wrap-cell",
            // editable: (params) =>
            //     (selectedViewBy !== 'Yearly' && selectedViewBy !== 'Monthly' && params.data.keyfigureName === "Updated Forecast Pickup"),
            // cellStyle: (params) => ({
            //     backgroundColor:
            //         (selectedViewBy !== 'Yearly' && selectedViewBy !== 'Monthly' && params.data.keyfigureName === "Updated Forecast Pickup")
            //             ? "#fff9e6"
            //             : undefined,
            // }),
            valueParser: (params) => {
                if (params.data.keyfigureName === "Comments") return params.newValue;
                const val = parseFloat(params.newValue);
                return isNaN(val) ? null : val;
            },
            // cellEditorSelector: (params) => {
            //     return { component: "agTextCellEditor" };
            // },

        })),
        {
            headerName: "Total", field: "total", width: 150,
            wrapText: true,
            autoHeight: true,
            cellClass: "wrap-cell",
            filter: "agSetColumnFilter",
            valueFormatter: (params) => formatTotal(params),
            filterParams: {
                valueFormatter: (params) => formatTotal(params),
            },
        },
    ];

    // const [filteredColumnsData, setFilteredColumnsData] = useState(columnDefs);

    const columnFilterDropdownOption = useMemo(() => {
        if (!columnDefs?.length) return [];
        return columnDefs.filter((col) => col.optionalField === true);
    }, [columnDefs]);

    // Filtered columns for AG Grid
    const filteredColumnsData = useMemo(() => {
        if (!columnDefs?.length) return [];
        return columnDefs.filter(
            (col) => !col.optionalField || !appliedHiddenColumns.includes(col.headerName)
        );
    }, [columnDefs, appliedHiddenColumns]);

    const defaultColDef = useMemo(
        () => ({
            sortable: true,
            filter: 'agMultiColumnFilter',
            filterParams: {
                filters: [
                    {
                        filter: 'agTextColumnFilter',
                        filterParams: {
                            suppressMiniFilter: false,
                        },
                    },
                    {
                        filter: 'agSetColumnFilter',
                        filterParams: {
                            excelMode: 'windows',
                            suppressMiniFilter: false,
                            buttons: ['apply', 'reset'],
                        },
                    },
                ],
            },
        }),
        []
    );

    const selectionColumnDef = useMemo(() => ({
        pinned: 'left'
    }))

    const onClickUploadButton = () => {
        setOpenUploadModal(true);
    }
    const onClickCloseUploadModal = () => {
        setOpenUploadModal(false);
    }

    const onSuccessFileUpload = () => {
        setSelectedRows([]);
        gridRef.current?.deselectAll();
        setDisableFilterBtn(true);
        getSupplierForecastTable(selectedViewBy, selectedStartingFrom);
    }

    const onClickDownloadButton = async () => {
        try {
            setIsDownloading(true);
            const excelData = gridApi.getDataAsExcel({
                fileName: "ForecastData",
                sheetName: "ForecastData"
            });
            const fieldMap = {
                "Supplier PIN": "supplierPIN",
                "Vendor Code": "supplierId",
                "Material Group": "materialGroup",
                "Planner Code": "plannerCode",
                "Plant Code": "plantCode",
            };

            const workbook = new ExcelJS.Workbook();
            await workbook.xlsx.load(new Blob([excelData]));
            const worksheet = workbook.worksheets[0];
            const rowData = [];
            gridApi.forEachNodeAfterFilterAndSort(node => rowData.push(node.data))

            worksheet.eachRow((row, rowNumber) => {
                if (rowNumber === 1) return; // skip header row
                const original = rowData[rowNumber - 2]; // Excel row 2 = rowData[0]
                if (!original) return;

                row.eachCell((cell, colNumber) => {
                    let headerVal = worksheet.getRow(1).getCell(colNumber).value;
                    if (typeof headerVal === "object" && headerVal.richText) {
                        headerVal = headerVal.richText.map(rt => rt.text).join("");
                    }
                    const field = fieldMap[headerVal];
                    if (field && original[field] != null) {
                        cell.value = "\u200B" + original[field].toString();
                        cell.numFmt = "@";
                        cell.protection = { locked: true }; // optional
                    }
                });
            });


            worksheet.views = [
                {
                    state: "frozen",
                    xSplit: 2,   // number of columns to freeze
                    ySplit: 1,   // keep header row frozen (optional but recommended)
                    topLeftCell: "C2",
                    activeCell: "C2"
                }
            ];

            worksheet.views = [
                {
                    state: "frozen",
                    xSplit: 2,   // number of columns to freeze
                    ySplit: 1,   // keep header row frozen (optional but recommended)
                    topLeftCell: "C2",
                    activeCell: "C2"
                }
            ];

            worksheet.getRow(1).eachCell(cell => {
                cell.protection = { locked: false };
            });
            worksheet.getRow(1).protection = { locked: false };
            worksheet.getRow(1).font = { bold: true };

            // ---------------- IDENTIFY COLUMNS ----------------
            let keyFigureColIndex;
            let totalColIndex = null;
            const dateColumnIndexes = [];

            worksheet.getRow(1).eachCell((cell, colNumber) => {
                const value = cell.value;

                if (value === "Key Figures") keyFigureColIndex = colNumber;
                if (value === "Total") totalColIndex = colNumber;

                if (typeof value === "string" && /\b\d{4}\b/.test(value)) {
                    dateColumnIndexes.push(colNumber);
                }
            });

            const lastDataRow = worksheet.lastRow?.number || worksheet.rowCount || 1;

            // ---------------- LOCK LEFT SECTION ----------------
            for (let row = 1; row <= lastDataRow; row++) {
                for (let col = 1; col <= keyFigureColIndex; col++) {
                    const cell = worksheet.getRow(row).getCell(col);

                    cell.protection = { locked: true };
                    cell.fill = {
                        type: "pattern",
                        pattern: "solid",
                        fgColor: { argb: "FFF2F2F2" }
                    };
                }
            }

            // ---------------- LOCK DATE COLUMNS ----------------
            worksheet.eachRow((row, rowNumber) => {
                if (rowNumber === 1) return;

                dateColumnIndexes.forEach(colIndex => {
                    const cell = row.getCell(colIndex);
                    cell.protection = { locked: true };
                    cell.fill = null;
                });
            });

            // ---------------- ENABLE FILTERS ----------------
            const lastCol = worksheet.columnCount;
            const lastColLetter = worksheet.getColumn(lastCol).letter;

            worksheet.autoFilter = {
                from: "A1",
                to: `${lastColLetter}1`
            };

            // ---------------- EDITABLE LOGIC ----------------
            // worksheet.eachRow((row, rowNumber) => {
            //     if (rowNumber === 1) return;

            //     const keyFigureValue = row.getCell(keyFigureColIndex).value;

            //     const isEditableRow =
            //         keyFigureValue === "Updated Forecast Pickup"

            //     if (isEditableRow && selectedViewBy === "Weekly") {
            //         dateColumnIndexes.forEach(colIndex => {
            //             const cell = row.getCell(colIndex);

            //             cell.protection = { locked: false };
            //             cell.fill = {
            //                 type: "pattern",
            //                 pattern: "solid",
            //                 fgColor: { argb: "FFFFF9E6" }
            //             };
            //         });
            //     }
            // });

            // ---------------- TOTAL FORMULAS ----------------
            if (totalColIndex && dateColumnIndexes.length > 0) {
                const startColLetter = worksheet.getColumn(dateColumnIndexes[0]).letter;
                const endColLetter =
                    worksheet.getColumn(dateColumnIndexes[dateColumnIndexes.length - 1]).letter;

                worksheet.eachRow((row, rowNumber) => {
                    if (rowNumber === 1) return;

                    row.getCell(totalColIndex).value = {
                        formula: `SUM(${startColLetter}${rowNumber}:${endColLetter}${rowNumber})`
                    };

                    row.getCell(totalColIndex).protection = { locked: true };
                });
            }
            const borderStyle = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" }
            };
            worksheet.eachRow({ includeEmpty: true }, (row) => {
                row.eachCell({ includeEmpty: true }, (cell) => {
                    cell.border = borderStyle;
                });
            });
            // ---------------- PROTECT SHEET ----------------
            await worksheet.protect("Forecast", {
                selectLockedCells: true,
                selectUnlockedCells: true,
                formatCells: true,
                formatColumns: true,
                formatRows: true,
                insertRows: false,
                insertColumns: false,
                deleteRows: true,
                deleteColumns: true,
                sort: true,
                autoFilter: true
            });

            // ---------------- DOWNLOAD ----------------
            const buffer = await workbook.xlsx.writeBuffer();
            saveAs(new Blob([buffer]), "ForecastData.xlsx");

        } catch (error) {
            console.error("Excel download failed", error);
        } finally {
            setIsDownloading(false);
        }
    };

    const clearAllFilters = () => {
        if (gridRef.current) {
            gridRef.current.setFilterModel(null);
            localStorage.removeItem("savedVariantFilterModel");
            setDisableFilterBtn(true);
        }
    };

    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClickHide = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseHide = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    const handleHideColumnChange = (event) => {
        setSelectedColumns(event.target.value);
    };

    const renderDropdownValue = (selected) => {
        if (selected?.length === 0) return "Select Columns";
        if (selected?.length === 1) return columnFilterDropdownOption.find(col => col?.headerName === selected?.[0])?.headerName;

        const firstColumnName = columnFilterDropdownOption.find(col => col?.headerName === selected?.[0])?.headerName;
        return `${firstColumnName}, +${selected?.length - 1}`;
    };

    const handleOpenCopyPasteModal = (data) => {
        console.log("Opening copy-paste modal with data:", data);
        setOpenCopyPasteModal(true);
        setCopyPasteSelectedRowData(data)
    }
    const handleCloseCopyPasteModal = (a, b) => {
        if (loadingCopyPaste) return; // prevent closing while loading
        setOpenCopyPasteModal(false);
        setCopyPasteSelectedRowData({})

    }

    const handleCopyPasteConfirmation = () => {
        // Step 1: Immediately show loader and disable button
        setLoadingCopyPaste(true);

        // Step 2: Defer heavy processing to allow UI to repaint
        setTimeout(() => {
            const sourceRows = copyPasteSelectedRowData;
            if (!Array.isArray(sourceRows) || sourceRows.length === 0) {
                setLoadingCopyPaste(false); // No rows, hide loader
                return;
            }

            let nextSelectedRowsLocal = null;

            setRowData((prev) => {
                const updated = [...prev];

                sourceRows.forEach((sourceRow) => {
                    const targetRowIndex = updated.findIndex(
                        (r) =>
                            r.tcccMaterialNumber === sourceRow.tcccMaterialNumber &&
                            r.plantCode === sourceRow.plantCode &&
                            r.supplierId.split(" | ")[0] === sourceRow.supplierId.split(" | ")[0] &&
                            r.keyfigureName === "Updated Forecast Pickup"
                    );

                    if (targetRowIndex === -1) return;

                    const targetRow = { ...updated[targetRowIndex] };
                    const dateCols = Object.keys(sourceRow).filter((k) =>
                        k.match(/(\d{1,2} [A-Za-z]{3} \d{4})|([A-Za-z]{3} \d{4})|(\d{4})/)
                    );

                    const updatedFields = { ...(targetRow.updatedFields || {}) };
                    dateCols.forEach((col) => {
                        updatedFields[col] = {
                            old: targetRow[col],
                            new: sourceRow[col],
                        };
                        targetRow[col] = sourceRow[col];
                    });

                    targetRow.total = dateCols.reduce((sum, col) => {
                        const val = parseFloat(targetRow[col]);
                        return sum + (isNaN(val) ? 0 : val);
                    }, 0);

                    targetRow.updatedFields = updatedFields;
                    updated[targetRowIndex] = targetRow;

                    // Update selected rows state
                    setSelectedRows((prevSel) => {
                        const prevArr = Array.isArray(prevSel) ? [...prevSel] : [];
                        const existsIndex = prevArr.findIndex(
                            (r) =>
                                r.tcccMaterialNumber === targetRow.tcccMaterialNumber &&
                                r.keyfigureName === targetRow.keyfigureName
                        );

                        if (existsIndex !== -1) {
                            prevArr[existsIndex] = { ...targetRow };
                            nextSelectedRowsLocal = prevArr;
                        } else {
                            nextSelectedRowsLocal = [...prevArr, { ...targetRow }];
                        }

                        return nextSelectedRowsLocal;
                    });
                });

                // Re-select updated rows in the grid
                setTimeout(() => {
                    try {
                        const toKeep = nextSelectedRowsLocal || [];
                        gridRef.current?.forEachNode((node) => {
                            const shouldSelect = toKeep.some(
                                (r) =>
                                    r.tcccMaterialNumber === node.data.tcccMaterialNumber &&
                                    r.keyfigureName === node.data.keyfigureName
                            );
                            if (shouldSelect) node.setSelected(true, false);
                        });

                        gridRef.current?.refreshCells();
                    } catch (err) {
                        console.warn("Copy-paste reselect error:", err);
                    }

                    // Hide loader and close modal
                    setLoadingCopyPaste(false);
                    setOpenCopyPasteModal(false);
                    setCopyPasteSelectedRowData({});
                }, 50);

                return updated;
            });
        }, 50); // small delay to allow React to render loader
    };


    const checkVariantFilter = () => {
        if (!gridApi) return;

        if (savedFilterModel) {
            try {
                const parsedFilterModel = JSON.parse(savedFilterModel);
                gridApi.setFilterModel(parsedFilterModel);
                gridApi.onFilterChanged();
            } catch (e) {
                console.error("Error parsing saved filter model:", e);
            }
        }
    }

    useEffect(() => {
        checkVariantFilter()
    }, [gridApi]);

    const handleCreateVariantModal = () => {
        setVariantData(gridApi?.getFilterModel());
        setOpenCreateVariantModal(true);
    }

    const handleCloseCreateVariantModal = () => {
        setOpenCreateVariantModal(false)
    }
    const handleShowVariantModal = () => {
        setOpenShowVariantModal(true);
    }

    const handleCloseShowVariantModal = () => {
        setOpenShowVariantModal(false)
    }
    const onClickSelectVariant = (variant) => {
        if (!gridApi || !variant?.filterJson) return;

        try {
            const filterModel =
                typeof variant.filterJson === "string"
                    ? JSON.parse(variant.filterJson)
                    : variant.filterJson;

            localStorage.setItem("savedVariantFilterModel", JSON.stringify(filterModel));
            gridApi.setFilterModel(filterModel);
            gridApi.onFilterChanged();
        } catch (e) {
            console.error("Invalid filterJson:", variant.filterJson, e);
        }
    };

    const fetchHideColumnsData = async () => {
        try {
            const responseHideBuyerColumnData = await dispatch(getHideColumnsList({
                dynamicEndpoint: hiddenColumnsEndpoint,
                params: {
                    userEmail: userEmail,
                    screenType: userRole === "Supplier Admin" ? "ADMIN_FORECAST" : userRole === "Supplier Planner" ? "SUPPLIER_FORECAST" : userRole === "Global Planner" ? "BUYER_FORECAST" : userRole === "Regional Planner"
                        ? "REGIONAL_PLANNER" : userRole === "Global Viewer" ? "GLOBAL_VIEWER" :
                            userRole === "Regional Viewer"
                                ? "REGIONAL_VIEWER"
                                : "APP_ADMIN_FORECAST"
                }
            }));
            if (responseHideBuyerColumnData?.meta?.requestStatus === 'fulfilled') {
                setSelectedColumns(responseHideBuyerColumnData.payload);     // UI
                setAppliedHiddenColumns(responseHideBuyerColumnData.payload); // GRID
                setBadgeCount(responseHideBuyerColumnData.payload.length);
            } else {
                console.error('Failed to fetch data:', responseHideBuyerColumnData?.error);
                toast.error(responseHideBuyerColumnData?.payload?.errorMessage, {
                    autoClose: 2000,
                });
            }
        } catch (error) {
            console.error('API error:', error);
            toast.error(error, {
                autoClose: 2000,
            });
        }
    }

    const getOverrideRequestBody = (rows = []) => {
        const userEmail = localStorage.getItem("userEmail");
        if (!rows || rows.length === 0) return null;

        const groupedRows = {};

        // Group selectedRows by supplier + material + plant + businessCategory
        rows.forEach((row) => {
            const key = `${row.supplierId}|${row.tcccMaterialNumber}|${row.plantCode}|${row.businessCategory}`;
            if (!groupedRows[key]) groupedRows[key] = [];
            groupedRows[key].push(row);
        });

        const forecastOverrideDetailsList = [];

        // Regex to match date formats: "05 Jan 2026", "Jan 2026", "2026"
        const dateKeyRegex = /(\d{1,2} [A-Za-z]{3} \d{4})|([A-Za-z]{3} \d{4})|(\d{4})/;

        Object.values(groupedRows).forEach((rows) => {
            const firstRow = rows[0];
            const timelineMapForecast = {};

            rows.forEach((row) => {

                // -----------------------------
                // FORECAST → SEND ALL DATES
                // -----------------------------

                Object.entries(row).forEach(([key, value]) => {
                    if (dateKeyRegex.test(key) && typeof value === "number") {
                        timelineMapForecast[key] = {
                            forecastDate: key,
                            supplierQuantity: Number(value),
                        };
                    }
                });

                // Override updatedFields if any
                Object.entries(row.updatedFields || {}).forEach(([date, change]) => {
                    if (change?.new !== undefined && change.new !== "") {
                        timelineMapForecast[date] = {
                            forecastDate: date,
                            supplierQuantity: Number(change.new),
                        };
                    }
                });

            });

            if (Object.keys(timelineMapForecast).length > 0) {
                forecastOverrideDetailsList.push({
                    supplier: firstRow.supplierId?.split(" | ")[0] || "",
                    material: firstRow.tcccMaterialNumber,
                    plant: firstRow.plantCode,
                    businessCategory: firstRow.businessCategory,
                    timelineOverrideList: Object.values(timelineMapForecast),
                });
            }
        });

        return {
            userEmail,
            forecastOverrideDetailsList
        };
    };

    const getBuyerForecastSaveDataTable = async (rows) => {
        const requestBody = getOverrideRequestBody(rows);

        try {
            const responseBuyerForecastSaveData = await dispatch(getBuyerForecastSaveDataSlice({
                dynamicEndpoint: `${getBuyerForecastSaveDataEndpoint}`,
                data: requestBody
            }));

            if (responseBuyerForecastSaveData?.meta?.requestStatus === 'fulfilled') {
                toast.success(responseBuyerForecastSaveData?.payload, {
                    autoClose: 2000,
                });

            }
            else {
                toast.error(responseBuyerForecastSaveData?.payload?.errorMessage, {
                    autoClose: 2000,
                });
            }
        } catch (error) {
            console.error('API error:', error);
        }
        finally {
            setSelectedRows([]);
            gridApi?.deselectAll();
            setDisableFilterBtn(true);
            getSupplierForecastTable(selectedViewBy, selectedStartingFrom);
            setIsRadioSelected(false)
        }
    }

    const getOverrideRequestBodyForSubmit = (rows) => {
        const userEmail = localStorage.getItem("userEmail");
        const groupedRows = {};
        const dateKeyRegex = /(\d{1,2} [A-Za-z]{3} \d{4})|([A-Za-z]{3} \d{4})|(\d{4})/;

        rows.forEach((row) => {
            const key = `${row.supplierId}|${row.tcccMaterialNumber}|${row.plantCode}|${row.businessCategory}`;
            if (!groupedRows[key]) groupedRows[key] = [];
            groupedRows[key].push(row);
        });

        const forecastOverrideDetailsList = [];

        Object.values(groupedRows).forEach((rows) => {
            const firstRow = rows[0];
            const timelineMapForecast = {};

            rows.forEach((row) => {
                Object.entries(row).forEach(([key, value]) => {
                    if (dateKeyRegex.test(key) && typeof value === "number") {
                        timelineMapForecast[key] = {
                            forecastDate: key,
                            supplierQuantity: Number(value),
                        };
                    }
                });
            });

            forecastOverrideDetailsList.push({
                supplier: firstRow.supplierId?.split(" | ")[0] || "",
                material: firstRow.tcccMaterialNumber,
                plant: firstRow.plantCode,
                businessCategory: firstRow.businessCategory,
                timelineOverrideList: Object.values(timelineMapForecast),
            });
        });

        return {
            userEmail,
            forecastOverrideDetailsList
        };
    };

    const submitBuyerForecastOverrideData = async () => {

        // USE ALL ROWS INSTEAD OF SELECTED ROWS
        const allRows = rowData.filter(
            row =>
                row.keyfigureName === "Updated Forecast Pickup"
        );

        if (!allRows.length) return;

        const requestBody = getOverrideRequestBodyForSubmit(allRows);

        try {
            const responseBuyerForecastSumitData = await dispatch(
                submitBuyerForecastOverrideDataSlice({
                    dynamicEndpoint: `${submitBuyerForecastOverrideDataEndpoint}`,
                    data: requestBody
                })
            );

            if (responseBuyerForecastSumitData?.meta?.requestStatus === 'fulfilled') {
                toast.success(responseBuyerForecastSumitData?.payload, {
                    autoClose: 2000,
                });
            } else {
                toast.error(responseBuyerForecastSumitData?.payload?.errorMessage, {
                    autoClose: 2000,
                });
            }
        } catch (error) {
            console.error('API error:', error);
        } finally {
            setSelectedRows([]);
            gridApi?.deselectAll();
            getSupplierForecastTable(selectedViewBy, selectedStartingFrom);
        }
    };

    const onClickSaveChanges = () => {
        // commit active editing cell
        gridRef.current?.stopEditing();

        setTimeout(() => {

            // get only checked + edited rows
            const checkedEditedRows = [];

            gridRef.current?.forEachNode((node) => {

                // only checked rows
                if (node.isSelected()) {

                    // find edited row
                    const editedRow = editedRowsRef.current.find(
                        (r) =>
                            r.tcccMaterialNumber === node.data.tcccMaterialNumber &&
                            r.keyfigureName === node.data.keyfigureName
                    );

                    // push only edited rows
                    if (editedRow) {
                        checkedEditedRows.push(editedRow);
                    }
                }

            });

            // send only checked edited rows
            getBuyerForecastSaveDataTable(checkedEditedRows);

        }, 0);
    }

    const onClickSubmitForecast = () => {
        submitBuyerForecastOverrideData();
    }

    const isSubmitEnabled = useMemo(() => {
        if (!rowData || rowData.length === 0) return false;

        return rowData.some(row => {
            if (!row.lastCustUpdate) return false;

            const enableDate = dayjs(row.lastCustUpdate, "DD MMM YYYY").add(5, "day");

            return dayjs().isAfter(enableDate) || dayjs().isSame(enableDate, "day");
        });

    }, [rowData]);

    const onCellValueChanged = useCallback((params) => {
        const { colDef, data, oldValue, newValue, api, node } = params;
        if (oldValue === newValue) return;

        const field = colDef.field;

        // store updated values
        data.updatedFields = {
            ...(data.updatedFields || {}),
            [field]: {
                old: oldValue,
                new: newValue,
            },
        };

        // recalculate total
        data.total = calculateTotal(data);

        // refresh cells
        api.refreshCells({
            rowNodes: [node],
            columns: [field, "total"],
            force: true
        });

        // auto select row
        if (!node.isSelected()) {
            node.setSelected(true);
        }

        // IMPORTANT:
        // update ref synchronously
        const existingIndex = editedRowsRef.current.findIndex(
            (r) =>
                r.tcccMaterialNumber === data.tcccMaterialNumber &&
                r.keyfigureName === data.keyfigureName
        );

        if (existingIndex !== -1) {
            editedRowsRef.current[existingIndex] = { ...data };
        } else {
            editedRowsRef.current.push({ ...data });
        }

        // optional UI state
        setSelectedRows([...editedRowsRef.current]);

    }, []);

    const onSelectionChanged = (params) => {
        const filteredSelectedRows = [];
        params?.api?.forEachNodeAfterFilter((node) => {
            if (node.isSelected()) {
                filteredSelectedRows.push(node.data);
            }
        });
        setSelectedRows(filteredSelectedRows);
        if (filteredSelectedRows.length > 0) {
            dispatch(setGridSelectedRows({ rows: filteredSelectedRows, gridId: 'cps-regionalviewer' }));
        } else {
            dispatch(clearGridSelectedRows());
        }
    }
    const rowSelection = useMemo(() => {
        return {
            mode: 'multiRow',
            isRowSelectable: (rowNode) => rowNode?.data?.keyfigureName === "Updated Forecast Pickup" && selectedViewBy !== 'Yearly' && selectedViewBy !== 'Monthly',
        }
    })


    const CHUNK_SIZE = 200; // adjust based on performance

    const processInChunks = async (nodes, callback) => {
        for (let i = 0; i < nodes.length; i += CHUNK_SIZE) {
            const chunk = nodes.slice(i, i + CHUNK_SIZE);
            chunk.forEach(callback);
            await new Promise((resolve) => setTimeout(resolve, 0)); // yield to UI
        }
    };

    // const onClickCopyForecast = async () => {
    //   if (!gridRef.current) return;
    //   const gridApi = gridRef.current;

    //   //  STEP 1: open confirmation popup immediately
    //   setOpenCopyPasteModal(true);

    //   // STEP 2: yield so popup renders
    //   await new Promise((resolve) => setTimeout(resolve, 0));

    //   const selectedNodes = gridApi.getSelectedNodes();

    //   // ======================
    //   // CASE 1: Selected rows
    //   // ======================
    //   if (selectedNodes.length > 0) {
    //     const filteredRows = [];

    //     await processInChunks(selectedNodes, (node) => {
    //       const nodeData = node.data;
    //       if (!nodeData) return;

    //       gridApi.forEachNodeAfterFilter((forecastNode) => {
    //         const forecastData = forecastNode.data;
    //         if (!forecastData) return;

    //         if (
    //           forecastData.keyfigureName === "Forecast Pick Up" &&
    //           forecastData.tcccMaterialNumber === nodeData.tcccMaterialNumber &&
    //           forecastData.plantCode === nodeData.plantCode &&
    //           forecastData.supplierId === nodeData.supplierId
    //         ) {
    //           forecastNode.setSelected(true, false);
    //           filteredRows.push(forecastData);
    //         }
    //       });
    //     });

    //     handleOpenCopyPasteModal(filteredRows);
    //     return;
    //   }

    //   // ======================
    //   // CASE 2: No selection (large data)
    //   // ======================
    //   const allForecastRows = [];
    //   const supplierMap = new Map();

    //   const rowCount = gridApi.getDisplayedRowCount();

    //   for (let start = 0; start < rowCount; start += CHUNK_SIZE) {
    //     const end = Math.min(start + CHUNK_SIZE, rowCount);

    //     for (let i = start; i < end; i++) {
    //       const rowNode = gridApi.getDisplayedRowAtIndex(i);
    //       const data = rowNode?.data;
    //       if (!data) continue;

    //       if (data.keyfigureName === "Forecast Pick Up") {
    //         allForecastRows.push(data);
    //       } else if (data.keyfigureName === "Updated Forecast Pickup") {
    //         const key = `${data.tcccMaterialNumber}|${data.plant}|${data.supplierId}`;
    //         if (!supplierMap?.has(key)) supplierMap?.set(key, []);
    //         supplierMap?.get(key).push(rowNode);
    //       }
    //     }

    //     // keep UI responsive
    //     await new Promise((resolve) => setTimeout(resolve, 0));
    //   }

    //   const forecastRows = [];

    //   await processInChunks(allForecastRows, (forecastData) => {
    //     const key = `${forecastData.tcccMaterialNumber}|${forecastData.plant}|${forecastData.supplierId}`;
    //     if (supplierMap?.has(key)) {
    //       forecastRows.push(forecastData);
    //     }
    //   });

    //   handleOpenCopyPasteModal(forecastRows);
    // };

    const handleSave = async () => {
        const responseBody = {
            "userEmail": userEmail,
            "hiddenColumns": selectedColumns,
            "screenType": userRole === "Supplier Admin" ? "ADMIN_FORECAST" : userRole === "Supplier Planner" ? "SUPPLIER_FORECAST" : userRole === "Global Planner" ? "BUYER_FORECAST" : userRole === "Regional Planner"
                ? "REGIONAL_PLANNER" : userRole === "Global Viewer" ? "GLOBAL_VIEWER" :
                    userRole === "REGIONALVIEWER"
                        ? "REGIONAL_VIEWER"
                        : "APP_ADMIN_FORECAST"
        }

        try {
            const responsePostHideColumns = await dispatch(postHideColumns({
                dynamicEndpoint: `${hiddenColumnsEndpoint}`,
                data: responseBody
            }));
            if (responsePostHideColumns?.meta?.requestStatus === 'fulfilled') {
                setAppliedHiddenColumns(selectedColumns);
                setBadgeCount(selectedColumns.length);
                handleCloseHide();
            } else {
                console.error('Failed to fetch data:', responsePostHideColumns?.error);
                toast.error(responsePostHideColumns?.payload?.errorMessage, {
                    autoClose: 2000,
                });
            }
        } catch (error) {
            console.error('API error:', error);
            toast.error(error, {
                autoClose: 2000,
            });
        }
    }


    return (
        <div>
            <div style={{ display: 'flex', marginTop: 10 }}>
                <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                    <div style={{ display: 'flex', gap: 10 }}>
                        <IconButton onClick={handleClickHide}>
                            <Badge badgeContent={badgeCount > 0 ? badgeCount : null} sx={{
                                "& .MuiBadge-badge": {
                                    fontSize: "0.6rem", // Smaller font size
                                    height: "16px", // Adjust badge height
                                    minWidth: "16px", // Adjust badge width
                                    padding: "4px", // Adjust padding
                                    background: '#000',
                                    color: '#fff'
                                },
                            }}
                            >
                                <MoreVertIcon />
                            </Badge>
                        </IconButton>

                        <Popover
                            open={Boolean(anchorEl)}
                            anchorEl={anchorEl}
                            onClose={handleCloseHide}
                            anchorOrigin={{ vertical: "top", horizontal: "right" }}
                            transformOrigin={{ vertical: "top", horizontal: "left" }}
                            className="hidePopover"
                            sx={{
                                marginTop: 1,
                                marginLeft: 0,
                            }}
                        >
                            <div style={{ padding: 10, width: 150 }}>
                                <p style={{ marginBottom: 10, marginTop: 5 }}>Hide Columns</p>
                                <Select
                                    multiple
                                    value={selectedColumns}
                                    onChange={handleHideColumnChange}
                                    renderValue={renderDropdownValue}
                                    displayEmpty
                                    sx={{ backgroundColor: "#fff", border: '1px solid #000', width: '100%', height: 35, marginBottom: 5 }}
                                >
                                    <MenuItem disabled value="">
                                        <em>Select Columns</em>
                                    </MenuItem>
                                    {columnFilterDropdownOption?.map(col => (
                                        <MenuItem key={col.headerName} value={col.headerName}>
                                            <Checkbox
                                                checked={!selectedColumns?.includes(col.headerName)}
                                            />
                                            <ListItemText primary={col.headerName} />
                                        </MenuItem>
                                    ))}
                                </Select>
                                {stateSelector?.PostHideColumnsSlice?.loading ?
                                    <Box style={{ textAlign: 'center' }}>
                                        <CircularProgress color="inherit" style={{ width: '20px', height: '20px', textAlign: 'center' }} />
                                    </Box>
                                    :
                                    <ButtonComponent type="secondary" label="Save" onClick={handleSave} />
                                }
                            </div>
                        </Popover>
                    </div>
                    <ButtonComponent
                        maxWidth="70px"
                        height="40px"
                        fontSize="12px"
                        label="Clear Filters"
                        bgColor="black"
                        color="white"
                        disabled={disableFilterBtn}
                        onClick={clearAllFilters}
                    />
                    {/* <ButtonComponent
                        type="secondary"
                        maxWidth="130px"
                        label="Save"
                        height="30px"
                        disabled={selectedRows?.length === 0 || hasDpsData || selectedViewBy === 'Yearly' || selectedViewBy === 'Monthly' || saveTable.loading}
                        onClick={onClickSaveChanges}
                    /> */}
                    {/* <ButtonComponent
                        type="secondary"
                        maxWidth="130px"
                        label="Submit"
                        height="30px"
                        disabled={submitForecast.loading || hasDpsData || !isRadioSelected || selectedViewBy === 'Yearly' || selectedViewBy === 'Monthly'}
                        onClick={onClickSubmitForecast}
                    /> */}
                    {/* <FormControlLabel
                        control={
                            <Radio
                                size="small"
                                checked={isRadioSelected}
                                disabled={hasDpsData || selectedViewBy === 'Yearly' || selectedViewBy === 'Monthly'}
                                onClick={() => {
                                    setIsRadioSelected((prev) => !prev);
                                }}
                                sx={{
                                    color: "black",
                                    "&.Mui-checked": {
                                        color: "black"
                                    }
                                }}

                            />
                        }
                        label="Ad hoc Submit"
                        sx={{
                            "& .MuiFormControlLabel-label": {
                                fontSize: 15, // change font size
                                color: "black",  // optional: label color
                            },
                        }}
                    /> */}
                    {/* <ButtonComponent
            type="primary"
            maxWidth={isDownloading ? "120px" : "100px"}
            label={isDownloading ? "Downloading" : "Download"}
            disabled={(!isDownloading && rowData?.length !== 0) ? false : true}
            height="30px"
            onClick={onClickDownloadButton}
          /> */}
                    <FileDownloadIcon
                        disabled={(!isDownloading && rowData?.length !== 0) ? false : true}
                        style={{
                            cursor: 'pointer',
                            fontSize: 24,
                            border: "1px solid black",
                            borderRadius: "4px",
                            padding: "2px",
                            opacity: (!isDownloading && rowData?.length !== 0) ? 1 : 0.4,
                            pointerEvents: (!isDownloading && rowData?.length !== 0) ? "auto" : "none"
                        }}
                        onClick={!isDownloading && rowData?.length !== 0 ? onClickDownloadButton : undefined}
                        titleAccess={"Download"}
                    />
                    {/* <FileUploadIcon
                        onClick={onClickUploadButton}
                        style={{
                            cursor: 'pointer', fontSize: 24,
                            border: "1px solid black",
                            borderRadius: "4px",
                            padding: "2px"
                        }}
                        titleAccess={"Upload"}
                    /> */}
                    {/* <ButtonComponent
            type="primary"
            maxWidth="100px"
            label="Upload"
            height="30px"
            onClick={onClickUploadButton}
          /> */}
                    <div
                        style={{
                            display: "flex",
                            gap: "6px", // Adjust as needed
                            marginLeft: "5px", // Space from previous content
                            paddingTop: "4px"
                        }}
                    >
                        <ButtonComponent
                            maxWidth="100px"
                            height="40px"
                            label="Create/Edit Variant"
                            bgColor="black"
                            color="white"
                            onClick={handleCreateVariantModal}
                            fontSize="12px"
                        />

                        <ButtonComponent
                            maxWidth="80px"
                            height="40px"
                            label="Show Variants"
                            bgColor="black"
                            color="white"
                            onClick={handleShowVariantModal}
                            fontSize="12px"
                        />
                    </div>
                </div>
            </div>
            <div style={{ margin: '10px 0px' }}>
                {(isLoading || stateBuyerForecastTableDataSlice?.loading || SubmitBuyerForecastOverrideDataSlice?.loading) ? <Loader /> :
                    <>
                        {originalData && originalData?.length > 0 ?
                            <div className="ag-theme-quartz" style={{ height: 400, width: '100%' }}>
                                <AgGridReact
                                    ref={gridRef}
                                    rowData={rowData}
                                    columnDefs={filteredColumnsData}
                                    onGridReady={onGridReady}
                                    gridOptions={gridOptions}
                                    onSortChanged={onSortChanged}
                                    selectionColumnDef={selectionColumnDef}
                                    onCellValueChanged={onCellValueChanged}
                                    onCellEditingStarted={(params) => {
                                        // auto check checkbox
                                        if (!params.node.isSelected()) {
                                            params.node.setSelected(true);
                                        }

                                        // update selectedRows immediately
                                        setSelectedRows((prev) => {
                                            const exists = prev.find(
                                                (r) =>
                                                    r.tcccMaterialNumber === params.data.tcccMaterialNumber &&
                                                    r.keyfigureName === params.data.keyfigureName
                                            );

                                            if (exists) return prev;

                                            return [...prev, { ...params.data }];
                                        });
                                    }}
                                    defaultColDef={defaultColDef}
                                    pagination={pagination}
                                    paginationPageSize={paginationPageSize}
                                    paginationPageSizeSelector={paginationPageSizeSelector}
                                    // rowSelection={rowSelection}
                                    onSelectionChanged={onSelectionChanged}
                                />
                                <CopyPasteDateRows openCopyPasteModal={openCopyPasteModal} copyPasteSelectedRowData={copyPasteSelectedRowData} handleCloseCopyPasteModal={handleCloseCopyPasteModal} handleCopyPasteConfirmation={handleCopyPasteConfirmation} loadingCopyPaste={loadingCopyPaste} />
                                <HistoryDataTable openHistoryModal={openHistoryModal} historySelectedRowData={historySelectedRowData} handleCloseShowHistoryModal={handleCloseShowHistoryModal} selectedStartingFrom={selectedStartingFrom} selectedViewBy={selectedViewBy} />
                                <div>
                                    <VariantViewModal tableType={"FORECAST"} openCreateVariantModal={openCreateVariantModal} handleCloseCreateVariantModal={handleCloseCreateVariantModal} data={variantData} />
                                </div>
                                <div>
                                    <ShowVariantViewModal tableType={"FORECAST"} openShowVariantModal={openShowVariantModal} handleCloseShowVariantModal={handleCloseShowVariantModal} data={variantData} onClickSelectVariant={onClickSelectVariant} />
                                </div>
                            </div>
                            :
                            <div style={{ margin: '10px 0px', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                                {originalData?.length === 0 ? <span>No Data Available</span> : <></>}
                            </div>
                        }
                    </>}
            </div>
            <UploadExcelModal openUploadModal={openUploadModal} handleCloseUploadModal={onClickCloseUploadModal} onSuccessFileUpload={onSuccessFileUpload} />
        </div>
    );
};

export default RegionalViewerDataTable;
